import { useUser } from '@clerk/clerk-react'

/**
 * Hook that checks if the current user has the admin role.
 * Reads from Clerk publicMetadata set via the Clerk Dashboard.
 */
export function useAdmin(): boolean {
  const { user } = useUser()

  if (!user) return false

  const metadata = user.publicMetadata as { role?: string } | undefined
  return metadata?.role === 'admin'
}
